/* shop-locations-filter.js — v2 robust (auto-find & wait for table) */
(function () {
  // หาตัวกรองจากทั้งหน้า (ไม่บังคับให้ต้องอยู่ใน wrapper เดียวกัน)
  const nameInput = document.getElementById('filterName');
  const addrInput = document.getElementById('filterAddr');
  const clearBtn  = document.getElementById('filterClear');
  const metaBox   = document.getElementById('filterMeta');

  // ถ้าไม่พบช่องกรอง ก็พอแค่นี้ (แปลว่าหน้าไม่มีฟิลเตอร์)
  if (!nameInput || !addrInput || !clearBtn || !metaBox) return;

  // ฟังก์ชันหา tbody ของตารางสาขา
  const findTbody = () => {
    // เลือกตารางแรกที่มี class .shop-table และมี <tbody>
    const tables = Array.from(document.querySelectorAll('table.shop-table'));
    for (const tb of tables) {
      const tbody = tb.querySelector('tbody');
      if (tbody && tbody.querySelectorAll('tr').length) return tbody;
    }
    return null;
  };

  // ทำงานจริงเมื่อเจอตารางแล้ว
  const boot = (tbody) => {
    // ป้องกันการบูตซ้ำ
    if (tbody.__wacoalFilterBound) return;
    tbody.__wacoalFilterBound = true;

    const rows = Array.from(tbody.querySelectorAll('tr'))
      .filter(tr => tr.querySelectorAll('td').length >= 3);
    const total = rows.length;

    const normalize = (s) => (s || '')
      .toString()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();

    const cache = rows.map(tr => {
      const tds = tr.querySelectorAll('td');
      return {
        tr,
        name: normalize(tds[1]?.textContent),
        addr: normalize(tds[2]?.textContent)
      };
    });

    const updateMeta = (visibleCount) => {
      const nameVal = nameInput.value.trim();
      const addrVal = addrInput.value.trim();
      const hasFilter = nameVal || addrVal;
      metaBox.textContent = hasFilter
        ? `พบ ${visibleCount.toLocaleString()} จากทั้งหมด ${total.toLocaleString()} สาขา`
        : `ทั้งหมด ${total.toLocaleString()} สาขา`;
    };

    const apply = () => {
      const qName = normalize(nameInput.value);
      const qAddr = normalize(addrInput.value);
      let visible = 0;

      cache.forEach(({ tr, name, addr }) => {
        const okName = qName ? name.includes(qName) : true;
        const okAddr = qAddr ? addr.includes(qAddr) : true;
        const show = okName && okAddr;
        tr.style.display = show ? '' : 'none';
        if (show) visible++;
      });

      // รีเซ็ตเลข No. ตามลำดับที่มองเห็น
      let run = 0;
      rows.forEach(tr => {
        const noCell = tr.querySelector('td:first-child');
        if (tr.style.display !== 'none') {
          run++;
          if (noCell) noCell.textContent = String(run);
        }
      });

      updateMeta(visible);
    };

    // ผูก events (debounce)
    let timer = null;
    const debounced = () => { clearTimeout(timer); timer = setTimeout(apply, 120); };
    nameInput.addEventListener('input', debounced);
    addrInput.addEventListener('input', debounced);
    clearBtn.addEventListener('click', () => {
      nameInput.value = '';
      addrInput.value = '';
      apply();
      nameInput.focus();
    });

    // รองรับ ?name=&addr= ใน URL
    try {
      const params = new URLSearchParams(location.search);
      const qsName = params.get('name');
      const qsAddr = params.get('addr');
      if (qsName) nameInput.value = decodeURIComponent(qsName);
      if (qsAddr) addrInput.value = decodeURIComponent(qsAddr);
    } catch (_) {}

    // เริ่มต้น
    updateMeta(total);
    apply();
  };

  // 1) ลองหา tbody ทันที
  let tbody = findTbody();
  if (tbody) {
    boot(tbody);
    return;
  }

  // 2) ถ้ายังไม่เจอ รอให้ DOM โหลดครบ
  document.addEventListener('DOMContentLoaded', () => {
    const tb = findTbody();
    if (tb) {
      boot(tb);
      return;
    }
  });

  // 3) ยังไม่เจออีก? ใช้ MutationObserver เฝ้าทั้งหน้า (รองรับ lazy sections)
  const mo = new MutationObserver(() => {
    const tb = findTbody();
    if (tb) {
      mo.disconnect();
      boot(tb);
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
